module.exports = __webpack_public_path__ + "68ef9553086453b7e0daa405d6db7eaa.png";